import './styles.scss';

// SIZES => big / middle / small / super-small
const GradientText = ({ children, size = 'big', textColor = 'black' }) => (
    <div className={`gradient-text gradient-text--${size} gradient-text--${textColor}`}>{children}</div>
);

export default GradientText;
